module.exports = __webpack_public_path__ + "static/space_DOD-528e04d947c3cd3b840afc6f39cb5190.svg";